<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <template v-if="$auth('markets.save')">
            <a-button type="primary" v-action:save icon="plus" @click="handleAdd" style="margin-right:10px">新增</a-button>
          </template>
          <template v-if="$auth('markets.delete')">
            <a-popconfirm
              title="确定要批量删除吗?"
              @confirm="batchDel">
              <a-button v-action:delete icon="delete">批量删除</a-button>
            </a-popconfirm>
          </template>
        </div>
        <!--表格-->
        <zm-table
          :columns="table.columns"
          :rowKey="record => record.id"
          :dataSource="table.data"
          :pagination="pagination"
          :loading="table.loading"
          @change="handleTableChange"
          :rowSelection="rowSelection"
          :scroll="{ x: 1320 }"
        >
          <template v-slot:actions="{ text, record }">
            <a href="javascript:;" @click="()=>handleView(record)">查看</a>
            <template v-if="$auth('markets.save')">
              <a-divider type="vertical"/>
              <a href="javascript:;" v-action:save @click="()=>handleEdit(record)">编辑</a>
            </template>
            <template v-if="$auth('markets.saveFollow')">
              <a-divider type="vertical"/>
              <a href="javascript:;" v-action:save @click="()=>setFollow(record)">市场跟踪</a>
            </template>

            <a-divider type="vertical"></a-divider>
            <a-dropdown>
              <a class="ant-dropdown-link" href="#"> 更多
                <a-icon type="down"/>
              </a>
              <a-menu slot="overlay">
                <template v-if="$auth('markets.delete')">
                  <a-menu-item>
                    <a-popconfirm
                      v-if="table.data.length"
                      title="确定要删除吗?"
                      @confirm="() => onDelete(record)"
                    >
                      <a v-action:delete href="javascript:;">删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </template>
                <template v-if="$auth('markets.update')">
                  <a-menu-item>
                    <a href="javascript:;" v-action:update @click="changPerson(record)">变更负责人</a>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
          </template>

        </zm-table>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <flow-modal ref="flowModal" @refreshTable="initTableData"></flow-modal>
    <change-person-modal ref="changePersonModal" @refreshTable="initTableData"></change-person-modal>
  </div>
</template>

<script>
import { getMarketsList, deleteMarkets } from '@/api/markets'
import editModal from './modules/editModal'
import changePersonModal from './modules/changePersonModal'
import flowModal from './modules/flowModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
import { mapActions } from 'vuex'
import { getDictInfoByCode } from '@/api/dict'
import moment from 'moment'

export default {
  name: 'MarketsList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
    this.initData()
  },
  computed: {},
  components: {
    editModal,
    searchForm,
    baseCard,
    changePersonModal,
    flowModal
  },
  data () {
    return {

      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        columnWidth: 40,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [
          {
            title: '市场名称（项目）',
            width: 200,
            dataIndex: 'name'

          }, {
            title: '业主单位',
            width: 160,
            dataIndex: 'proprietorName'

          }, {
            title: '地区',
            width: 140,
            dataIndex: 'area'

          }, {
            title: '预估概算',
            width: 120,
            dataIndex: 'estimatedBudget'

          }, {
            title: '预估毛利',
            width: 120,
            dataIndex: 'estimatedOutput'

          }, {
            title: '市场跟进情况',
            width: 120,
            dataIndex: 'statusName'

          }, {
            title: '市场负责人',
            width: 100,
            dataIndex: 'leaderName'

          }, {
            title: '市场类型',
            width: 100,
            dataIndex: 'typeName'
            // width: 120
          }, {
            title: '操作',
            align: 'right',
            fixed: 'right',
            width: 220,
            scopedSlots:
                { customRender: 'actions' }
          }],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    ...mapActions(['handleMarketTypeList']),
    // 市场跟踪
    setFollow (model) {
      this.$refs.flowModal.setTitle('市场跟踪信息')
      this.$store.commit('marketModel', model)
      this.$store.commit('proprietorId', model.proprietorId)
      this.$refs.flowModal.open(true)
    },
    // 变更负责人
    changPerson (model) {
      this.$refs.changePersonModal.setTitle('变更负责人')
      this.$refs.changePersonModal.setModel(model) // 先设置类型，再打开
      this.$refs.changePersonModal.open(true)
    },
    initData () {
      // 初始化业主信息
      this.$store.dispatch('handleProprietorList')
      // 初始话设计代表列表
      this.$store.dispatch('handleDesignList')
      // 初始化人员列表
      this.$store.dispatch('handleUserList')
      // 初始化状态列表
      this.$store.dispatch('handleStatusList')
      // 初始化项目类型列表
      getDictInfoByCode({ pCode: 'MARKET_TYPE' }).then(res => {
        if (res.status === 0) {
          this.handleMarketTypeList(res.data)
        }
      })
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.table.filteredInfo = null
      this.table.sortedInfo = null
      delete this.searchModel.sortField
      delete this.searchModel.sortOrder
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true
      getMarketsList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.table.filteredInfo = filters
      this.table.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination,
        ...this.searchTableModel,
        sortField: sorter.field,
        sortOrder: sorter.order
      }
      this.initTableData()
    },
    // 删除操作
    onDelete (model) {
      deleteMarkets(model.id).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 查看详情
    handleView (model) {
      this.$refs.editModal.setTitle('查看市场信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.editModal.setModel(model) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑市场信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增市场信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      this.$refs.editModal.setModel({
        userId: this.$store.getters.userId,
        createTime: moment(new Date(), 'YYYY-MM-DD').utc(8)
      })
      this.$refs.editModal.open(true)
    },
    // 批量删除
    batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.error('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map(item => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      deleteMarkets(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
